import { CoreExecutorResult, } from "../../core/index.js";
import { PimExecutorResultFactory, loadPimSchema } from "./pim-executor-utils.js";
export async function executePimDeleteAttribute(reader, createNewIdentifier, operation) {
    const schema = await loadPimSchema(reader);
    if (schema === null) {
        return PimExecutorResultFactory.missingSchema();
    }
    return CoreExecutorResult.createSuccess([], [
        {
            ...schema,
            pimParts: schema.pimParts.filter((iri) => iri !== operation.pimAttribute),
        },
    ], [operation.pimAttribute]);
}
//# sourceMappingURL=pim-delete-attribute-executor.js.map